import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancelPage() {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-950 px-4">
      <div data-testid="payment-cancel-status" className="w-full max-w-md rounded-2xl border border-slate-800 bg-slate-900 p-8 text-center">
        <XCircle className="mx-auto h-14 w-14 text-slate-500" />
        <h1 className="mt-4 text-xl font-extrabold text-white">Pagamento cancelado</h1>
        <p className="mt-1 text-sm text-slate-400">Nenhuma cobrança foi feita. Você pode assinar quando quiser.</p>
        <div className="mt-6 flex gap-3">
          <button onClick={() => navigate("/premium")} className="flex-1 rounded-xl bg-amber-500 py-3 text-sm font-bold text-slate-950 hover:bg-amber-400">
            Tentar de novo
          </button>
          <button onClick={() => navigate("/inicio")} className="flex-1 rounded-xl bg-slate-700 py-3 text-sm font-bold text-white hover:bg-slate-600">
            Início
          </button>
        </div>
      </div>
    </div>
  );
}
